'use client';
import { FieldValues, Path, useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input, InputProps } from '@/components/ui/input';
import React from 'react';

interface FormInputProps<T extends FieldValues> extends InputProps {
  registerName: Path<T>;
  label: string;
  isRequired?: boolean;
}

const BaseFormInputField = <T extends FieldValues>(
  { registerName, label, isRequired, ...inputProps }: FormInputProps<T>,
  ref: React.Ref<HTMLInputElement>
) => {
  const { control } = useFormContext<T>();
  return (
    <FormField
      control={control}
      name={registerName}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {label}
            {isRequired && <span className="text-tomato-600">{' *'}</span>}
          </FormLabel>
          <FormControl>
            <Input className="mt-3" {...field} {...inputProps} ref={ref} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export const FormInputField = React.forwardRef(BaseFormInputField) as <
  T extends FieldValues,
>(
  inputFormProps: FormInputProps<T> & { ref?: React.Ref<HTMLInputElement> }
) => JSX.Element;
